import { ActionTypes } from "@/App/constants/actionTypes";
import { Action } from "@/App/actions";
import { BatchManualClaimTypes } from "@/types";

export interface BatchManualClaimState {
  batchManualClaim: BatchManualClaimTypes.BatchManualClaim;
}

const DEFAULT_GET_MANUAL_CLAIM_STATE: BatchManualClaimState = {
  batchManualClaim: {
    created_at: "",
    id: null,
    original_name: "",
    status: "",
  },
};

export default (state: BatchManualClaimState = DEFAULT_GET_MANUAL_CLAIM_STATE, action: Action): BatchManualClaimState => {
  if (action.type === ActionTypes.GET_BATCH_TRANSMISSION_MANUAL_CLAIM_RESULTS) {
    return {
      ...state,
      batchManualClaim: action.payload,
    };
  } else {
    return state;
  }
};
